import React from 'react';

export default function PlainTextMessage({ content }) {
  const text = typeof content === 'string' ? content : '';

  if (!text.trim()) {
    return 'אין מידע להצגה';
  }

  return <div className="message-text">{text}</div>;
}
